import React from 'react';
import EducationMain from '../EducationMain'
import Footer from '../Footer';

function Education() {
    window.scrollTo(0,0);
    return (
        <>
            <EducationMain />
            <Footer/>
        </>
    )
}

export default Education
